<template>
  <div class="wrapper" v-show="!hide">
    <div :class="['company',`${headerBgClass ? headerBgClass : ''}`].join(' ')" @click="showCompanyPopup">
      <div class='left'>
        <span class="company-name">{{companyInfo.name}}</span>
      </div>
      <div class="center-i">
        <i class="iconfont right-icon">&#xe648;</i>
      </div>
      <div @click.stop="gotoETaxLogin" v-if="isShowETaxLogin" class="face-recognition">
        <i class="allIconFont qrcode">{{'\ue611'}}</i>
      </div>
      <div @click.stop="gotoFaceRecognition" v-if="isShowfaceRecognition" class="face-recognition">
        <i class="allIconFont qrcode">{{'\ue6dd'}}</i>
      </div>
      <div class="right" @click.stop="gotoQrcode">
        <i class="huisuiyunfont qrcode">{{'\ue61a'}}</i>
      </div>
    </div>
    <van-popup v-model="showChangeCompany" closeable @close ="closeCompanyPopup" position="bottom" class="company-popup">
      <div class="wrap" style="position: relative">
        <div class="top">
          <div class="switch-title" @click="showChangeCompany = true">请选择切换的公司</div>
          <div class="search-wrp">
            <div class="search-ipt">
              <input type="text" v-model="companyNameParam" placeholder="公司名称" />
              <i @click="onSearchCompany" class="huixiaopiaofont">&#xe6f5;</i>
            </div>
          </div>
        </div>
        <div class="radio-wrap">
          <van-radio-group v-model="companyInfo.id">
            <van-radio
              :name="item.id"
              class="company-item"
              v-for="(item) in companyList"
              :key="item.id"
              icon-size=".64rem"
              @click="selectCompany(item.id)"
            >
              {{item.name}}
            </van-radio>
          </van-radio-group>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Popup,
  Radio,
  RadioGroup,
  Notify,
  Toast
} from 'vant'
import { accountRequest } from '@services'
import { localStorage } from '@utils/basicUtil'
import Observer from '@utils/observer'
import { wxAuth } from '@utils/plugin'

export default {
  components: {
    [Popup.name]: Popup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Notify.name]: Notify,
    [Toast.name]: Toast
  },
  props: {
    hide: {
      type: Boolean,
      default: false
    },
    headerBgClass: {
      type: String,
      default: ''
    },
    isShowfaceRecognition: {
      type: Boolean,
      default: false
    },
    isShowETaxLogin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showChangeCompany: false,
      companyList: [],
      companyData: [],
      companyNameParam: ''
    }
  },
  computed: {
    companyInfo () {
      return this.$store.state.user.company
    },
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  watch: {},
  created () {},
  mounted () {
    this.companyName = localStorage.get('companyName')
    this.companyId = localStorage.get('companyId')
    let XAccessToken = localStorage.get('X-Access-Token')
    if (XAccessToken) {
      if (!this.companyInfo.id) {
        this.getCompany()
      }
      if (!this.userInfo.account) {
        this.getUserInfo()
      }
      this.getIpConfig()
      // if (!window.resourceList) {
      //   this.queryResource()
      // }
    }
  },
  activated () {},
  updated () {},
  methods: {
    showCompanyPopup () {
      this.getCompany()
      this.showChangeCompany = true
    },
    closeCompanyPopup () {
      this.showChangeCompany = false
      this.companyNameParam = ''
      this.companyList = this.companyData
    },
    onSearchCompany () {
      this.companyList = this.companyData.filter((company) => company.name.indexOf(this.companyNameParam) >= 0)
    },
    async selectCompany (id) {
      Toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true
      })
      this.$store.commit('user/changeChangeCompanyFlag', true)
      this.$store.commit('invoice/changeBusinessGoodsList', [])
      this.showChangeCompany = false
      this.companyNameParam = ''
      const data = await accountRequest.company.changeCurrentCompany({ companyId: id })
      await this.getCompanyInfo(id)
      if (data.success) {
        localStorage.set('X-C-Token', data.result)
        this.showCompanies = false
        // await this.queryResource()
        Observer.runFunction({ type: 'changeCompany' }) // 发布changeCompany方法，注册了的方法都会执行
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      await this.$store.dispatch({
        type: 'user/getJurisdiction'
      })
      this.$store.commit('user/changeChangeCompanyFlag', false)
      Toast.clear()
    },
    async getCompanyInfo (id) {
      const detailData = await accountRequest.company.getCompanyDetail({}, { id: id })
      if (detailData.success) {
        const resCompany = detailData.result
        this.defaultCompany = resCompany.name
        this.defaultCompanyId = resCompany.id
        localStorage.set('companyId', resCompany.id)
        localStorage.set('companyName', resCompany.name)
        localStorage.set('invoiceLimits', resCompany.companyInfoResponse.invoiceType ? resCompany.companyInfoResponse.invoiceType.split(',').sort((a, b) => a - b).join(',') : '')
        localStorage.set('showTaxSign', resCompany.companyInfoResponse.showTaxSign)
        this.$store.commit('user/changeCompany', resCompany)
        this.$store.commit('invoice/changeGoodsList', [])
        this.$store.commit('invoice/changeSmartInvoiceLimits', resCompany.companyInfoResponse.invoiceType ? resCompany.companyInfoResponse.invoiceType.split(',').sort((a, b) => a - b).join(',') : '')
        this.$store.commit('invoice/initApplyData')
        await this.$store.dispatch({
          type: 'user/getInviteParam'
        })
        this.initReport()
        wxAuth()
      } else {
        Notify({ type: 'danger', message: detailData.message })
      }
    },
    async getUserInfo () {
      const info = await accountRequest.account.info({})

      if (info.success) {
        this.$store.commit('user/changeUserInfo', info.result)
        localStorage.set('registerFrom', info.result.registerFrom)
        localStorage.set('get-logo-userId', info.result.mainAccountId)
        this.initReport()
        wxAuth()
      } else {
        Notify({ type: 'danger', message: info.message })
      }
    },
    async getIpConfig () {
      const result = await accountRequest.company.queryIpConfig({ requestSource: '3' })
      if (result.success) {
        localStorage.set('ip-config-setting', result.result)
      }
    },
    async getCompany () {
      const postData = {
        size: 9999
      }
      const data = await accountRequest.company.getCompanyList(postData)
      if (data.success) {
        this.companyList = data.result.records
        this.companyData = data.result.records
        this.defaultCompany = data.result.currentCompany.name
        this.defaultCompanyId = data.result.currentCompany.id
        // 这里可能会有一种情况
        // 钉钉里直接在指定公司里单点登录过来，可能公司不一样，得判断下，localstorage里的id和当前X-C-Token的是否一致，不一致以localStorage为准
        let id = localStorage.get('companyId')
        if (!this.companyInfo.id) { // 判断当前有没有公司信息，没有去请求
          if (this.defaultCompanyId === id) { // 判断当前token里公司跟localStorage的id是否一样,一样就不再切换，防止有切过盘的情况
            this.getCompanyInfo(this.defaultCompanyId)
          } else { // 否则去切换
            this.selectCompany(id)
          }
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    // async queryResource () {
    //   const result = await accountRequest.account.queryResource({})
    //   if (result.success) {
    //     const resourceList = createResourceTree({ ...result.result })
    //     window.resourceList = resourceList
    //   }
    // },
    initReport () {
      let localhost = window.location.host
      let projectVersion = 'dev'
      if (localhost.indexOf('192') !== -1 || localhost.indexOf('localhost') !== -1) {
        projectVersion = 'dev'
      } else if (localhost.indexOf('dev') !== -1) {
        projectVersion = 'dev'
      } else {
        projectVersion = 'prod'
      }
      let companyId = localStorage.get('companyId')
      let account = this.userInfo.account
      let wmUserInfo = (localStorage.get('wmUserInfo') && JSON.parse(localStorage.get('wmUserInfo'))) || {}
      Object.assign(wmUserInfo, { userTag: companyId, projectVersion: projectVersion, userId: account })
      localStorage.set('wmUserInfo', JSON.stringify(wmUserInfo))
    },
    gotoQrcode () {
      this.$router.push('/user-center/company-qrcode')
    },
    gotoFaceRecognition () {
      this.$router.push('/faceRecognition/index')
    },
    gotoETaxLogin () {
      this.$router.push('/eTaxLogin/index')
    }
  }
}
</script>
<style scoped lang='less'>
.wrapper{
  height: 100%;
  max-height: 120px;
  .company{
    height: 100%;

    background: #fff;
    font-size: .68267rem;
    color: #3E4966;
    // font-weight: bold;
    padding: 0 0 0 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      // width: 100px !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .company-name{
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .iconfont{
        margin-left: 10px;
        font-size: 20px;
        color: #2B2E37;
      }
    }
    .center-i{
      flex-grow: 1;
      text-align: left;
    }
    .right{
      height: 100%;
      display: flex;
      align-items: center;
      margin: 0 30px;
      .qrcode{
        font-size: 48px;
        // font-weight: 100 !important;
        color: #3E4966;
      }
    }
    .face-recognition{
      height: 100%;
      display: flex;
      align-items: center;
      margin: 0 15px 0 30px;
      .qrcode{
        font-size: 48px;
        // font-weight: 100 !important;
        color: #3E4966;
      }
    }
  }
  .red{
     background: #F5F5F5;
     font-size: 40px;
  }
  .blue{
    background-color: #3378FF;
    color: #fff;
    font-size: 40px;
    font-weight: 400;
    i{
      color: #fff !important;
    }
  }
  .company-popup {
    height: 50%;
    /deep/.van-popup__close-icon--top-right {
      top: 10px;
    }
    .wrap {
      height: 100%;
    }

    .top {
      position: absolute;
      width: 100%;
      height: 160px;
      background: #fff;
      z-index: 1;
      .switch-title {
        width: 100%;
        text-align: center;
        padding-top: 20px;
        font-size:34px;
        font-weight:bold;
        color:rgba(51,51,51,1);
      }
    }
    .search-wrp {
      /deep/.van-field__right-icon {
        font-size: 60px;
      }
      .search-input {
        height:60px;
        background:rgba(255,255,255,1);
        border:1PX solid rgba(201,201,201,1);
        border-radius:5px;
        font-size:26px;
        padding: 10px 20px;
      }
      .search-ipt {
        width: 90%;
        margin: 10px auto;
        padding: 10px 18px;
        font-size: 26px;
        font-weight: 400;
        border-radius: 5px;
        border: none;
        height: 40px;
        overflow: hidden;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: solid 1px gray;
        i {
          color: #999;
          font-size: 35px;
        }
        input {
          border: 0;
          height: 30px;
          vertical-align: center;
          width: calc(100% - 50px);
          color: rgba(0, 0, 0, 0.8);
          outline: none;
          &::placeholder {
            color: rgba(187, 186, 186, 1);
          }
        }
      }
    }
    .radio-wrap {
      height: calc(100% - 160px);
      padding-top: 140px;
      overflow: scroll;
    }
    /deep/.van-radio__icon {
      margin: 0 40px 0 30px;
    }
    .company-item {
      font-size:30px;
      font-weight:500;
      color:rgba(51,51,51,1);
      height: 100px;
    }
  }
}
</style>
